import {Button, Checkbox, Form, Input, notification} from 'antd';
import "./loginIndex.css"
import {forwardRef, useState} from "react";
import {login} from "@/api/Api";
import {ACCESS_TOKEN, EXPIRE_TIME, LOGIN_ACCOUNT} from "@/Const";
import {useTranslation} from "react-i18next";
// import cookie from "react-cookies";

const LoginIndex = forwardRef(function _LoginIndex(props:{onCloseDialogEvent:any,onLoginSuccess:any},ref){
    const [submitLoading,setSubmitLoading] = useState(false);
    const {t} = useTranslation();
    const onFinish = (values: any) => {
        console.log('Success:', values);
        setSubmitLoading(true);
        login(values,()=>{
            setSubmitLoading(false);
        }).then((res:any)=>{
            var day30 = new Date();
            day30.setDate(day30.getDate()+30);
            // cookie.save(ACCESS_TOKEN,res,{expires:day30,path:'/'});
            // cookie.save(LOGIN_ACCOUNT,values.email,{expires:day30,path:'/'});
            localStorage.setItem(ACCESS_TOKEN,res);
            localStorage.setItem(LOGIN_ACCOUNT,values.email);
            localStorage.setItem(EXPIRE_TIME,day30.getTime().toString());
            props.onCloseDialogEvent(res);
            notification.info({message:t("Login success")});
            if (props.onLoginSuccess){
                props.onLoginSuccess();
            }
        })
    };

    const onFinishFailed = (errorInfo: any) => {
        console.log('Failed:', errorInfo);
    };

    type FieldType = {
        username?: string;
        password?: string;
        remember?: string;
    };

    return(
        <div>
            <h4>{t("Login")}</h4>

            <Form
                labelAlign={"left"}
                name="formLogin"
                labelCol={{ span: 6 }}
                wrapperCol={{ span: 16 }}
                style={{ maxWidth: 600,marginTop:'16px' }}
                initialValues={{ remember: true }}
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
                autoComplete="off"
            >
                <Form.Item<FieldType>
                    label={t("Email")}
                    name="email"
                    rules={[{ required: true, message: t("Please input your email")}]}
                >
                    <Input />
                </Form.Item>

                <Form.Item<FieldType>
                    label={t("Password")}
                    name="password"
                    rules={[{ required: true, message: t("Please input your password")}]}
                >
                    <Input.Password />
                </Form.Item>

                {/*<Form.Item<FieldType>*/}
                {/*    name="remember"*/}
                {/*    valuePropName="checked"*/}
                {/*    wrapperCol={{ offset: 8, span: 16 }}*/}
                {/*>*/}
                {/*    <Checkbox>Remember me</Checkbox>*/}
                {/*</Form.Item>*/}

                {/*<Form.Item wrapperCol={{ offset: 8, span: 16 }}>*/}
                {/*    <Button type="primary" htmlType="submit">*/}
                {/*        Submit*/}
                {/*    </Button>*/}
                {/*</Form.Item>*/}
                <div style={{display:'flex',justifyContent:'center',alignItems:'center'}}>
                    <Button className='large-w-button' onClick={()=>props.onCloseDialogEvent()}>{t("Cancel")}</Button>
                    <Button className='large-w-button button-solid-style'
                            loading={submitLoading}
                            type="primary"
                            style={{marginLeft:'26px'}}
                            htmlType={"submit"}>{t("Login")}</Button>
                </div>
            </Form>
        </div>

    )
})

export default LoginIndex;